import styled from "styled-components"
import { Colors } from "styles/app-styles"
import { Label_s } from 'styles/app-styles'

export const EditProfileForm = styled.div`
  display: grid;
  grid-template-columns: auto 15px auto;
  grid-template-rows: 75px 75px 75px;
  grid-template-areas: "first . last"
                       "email email email"
                       "org org org"
                       "terms terms terms";
  input {
    width: 100%;
  }
  label {
    margin-bottom: 10px;
  }
  > div {
    display: flex;
    flex-direction: column;
  }
  > div:first-child {
    grid-area: first
  }
  > div:nth-child(2) {
    grid-area: last
  }
  > div:nth-child(3) {
    grid-area: email
  }
  > div:nth-child(4) {
    grid-area: org
  }
  > div:last-child {
    grid-area: terms;
  }
`

export const ProfileButtons_s = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`

export const UpdatePasswordForm_s = styled.div`
  > div {
    margin-bottom: 10px !important;
  }
  a {
    color: ${Colors.denim} !important;
  }
  p {
    font-size: 14px;
    margin: 10px 0 15px 0
  }
  svg {
    height: 20px;
    margin-left: 10px;
    width: 20px;
  }
  input {
    border: 1px solid ${Colors.towerGrey};
    border-radius: 2px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    height: 30px;
    margin-top: 10px;
    width: 290px;
    &:focus {
      outline: none;
    }
    &:focus, &.p-focus {
      background-color: ${Colors.inputFocus};
      border-color: ${Colors.blackPearl};
    }
  }
`

export const AuthError = styled.div`
  color: white;
  background-color: ${Colors.colorDanger};
  display: inline-block;
  padding 4px;

  ul {
    list-style: circle;
    list-style-type: disc;
    list-style-position: inside;
    li {
      margin-left: 5px;
    }
  }
`
